// extracted by mini-css-extract-plugin
export default {"wrapper":"K8oE220lRZTulxXTvEqK"};